import React from "react";

interface SizeProps {
  height?: string;
  width?: string;
}

export default function CalendarIcon(props: SizeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.height ? props.height : "26.5"}
      height={props.width ? props.width : "26.5"}
      viewBox="0 0 26.5 26.5"
    >
      <g
        id="Icons_Line_Calendar"
        data-name="Icons / Line / Calendar"
        transform="translate(0.75 0.75)"
      >
        <rect
          id="Rectangle"
          width="25"
          height="23.333"
          rx="0.1"
          transform="translate(0 1.667)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path"
          d="M0,.05H25"
          transform="translate(0 8.283)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-2"
          data-name="Path"
          d="M.05,0V3.333"
          transform="translate(4.95)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-3"
          data-name="Path"
          d="M.05,0V3.333"
          transform="translate(19.95)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}
